import { render, staticRenderFns } from "./RevisionEntryConfigurationCrud.vue?vue&type=template&id=b8401312&scoped=true"
import script from "./RevisionEntryConfigurationCrud.vue?vue&type=script&lang=js"
export * from "./RevisionEntryConfigurationCrud.vue?vue&type=script&lang=js"
import style0 from "./RevisionEntryConfigurationCrud.vue?vue&type=style&index=0&id=b8401312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8401312",
  null
  
)

export default component.exports